import { BlockLoading } from '../fetch-status/block-loading';
import { MarketStatusView } from './market-status';
import { UserEarings } from './user-earnings';
import { ViewInfoIcon, ViewResultFinalIcon, ViewResultSettlementIcon } from '@/client/assets';
import { cn } from '@/client/utils';
import { api } from '@/client/utils/api';
import { useEventDetail } from '@/libs/react-sdk/api/use-event-detail';
import { useMarketDetail } from '@/libs/react-sdk/api/use-market-detail';
import { EventStatus, MarketStatus } from '@/libs/sdk/api';
import { useTranslation } from 'react-i18next';

type MarketResultProps = {
  className?: string;
  marketAddress: string;
  uid: string;
};
export const MarketResult = ({ className, marketAddress, uid }: MarketResultProps) => {
  const { t } = useTranslation();
  const market = useMarketDetail(api, { marketAddress });
  const eventId = market.data?.eventId ?? '';
  const event = useEventDetail(api, { eventId }, { enabled: Boolean(eventId) });
  const isVoided = event.data?.status === EventStatus.voided;

  if (!market.data || market.isLoading) return <BlockLoading />;

  // Voided event: show amber banner, hide claim/trade
  if (isVoided) {
    return (
      <div
        className={cn('border border-warning/20 bg-warning/10 p-6 rounded-3xl', className)}
        role="alert"
      >
        <div className="pt-2 space-y-3 text-center">
          <ViewInfoIcon className="size-10 fill-warning" />
          <h3 className="text-lg font-semibold text-warning">{t('market-voided', '此市場已取消')}</h3>
          <p className="text-sm text-warning/80">{t('market-voided-refund', '資金將按比例退回')}</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className={cn('border border-foreground/4 shadow-[0px_7px_15px_0px] shadow-foreground/10 p-4 rounded-3xl', className)}
    >
      <div className="pt-4 space-y-2">
        <div className="flex justify-center items-center">
          {market.data.marketStatus === MarketStatus.settlement && (
            <ViewResultSettlementIcon className="size-15 fill-beneficial" />
          )}
          {market.data.marketStatus === MarketStatus.disputed && (
            <ViewInfoIcon className="size-10 fill-warning" />
          )}
          {market.data.marketStatus === MarketStatus.closed && <ViewResultFinalIcon className="size-15 fill-beneficial" />}
        </div>
        <h3 className="text-center text-6 font-semibold leading-6 tracking-[-0.48px]">{t('results-out')}</h3>
      </div>
      <div className="space-y-2">
        <MarketStatusView marketAddress={marketAddress} className="mt-8 bg-foreground/4" />
        <UserEarings
          eventId={market.data.eventId}
          marketAddress={marketAddress}
          optionAddress={market.data.resultOptionAddress}
          marketStatus={market.data.marketStatus}
          isClaim={market.data.isClaim}
          optionsLen={market.data.optionList.length}
          uid={uid}
        />
      </div>
    </div>
  );
};
